 //
 // レイアウト構成指定用データ
 //
 export const layoutClassTable = [
        [15,["card-col4s",4]],
        [16,["card-col2p",2],["card-col2p",2]],
        [17,["card-col4s",4]],
        [18,["card-col2p",2],["card-col2p",2]],
        [46,["card-col3p",3],["card-col3p",3]],
        [50,["card-col2s",2],["card-col2s",2]],
        [60,["card-col3s",3],["card-col3s",3]],
        [61,["card-col3s",3]],
        [71,["card-col3s",3],["card-col2s",2]],
        [72,["card-col2p",2],["card-col2p",2],["card-col2p",2]],
	    [73,["card-col3p",3],["card-col2p",2]]
]


// WEBPACK FOOTER //
// ./src/mixin/TLayout.js